<template>
  <div>
    <top-title
      name="积分任务"
      style="margin: 20px; min-width: 980px"
    ></top-title>

    <div class="integralEden">
      <div class="content" v-if="createStep == 1">
        <!-- 头部导航切换 -->
        <div class="navTab" v-if="allHide == true">
          <span
            class="tab"
            :class="{ active: tabActive == 1 }"
            @click="tabActive = 1"
            >创建活动</span
          >
          <span
            class="tab"
            :class="{ active: tabActive == 2 }"
            @click="tabActive = 2"
            >活动管理</span
          >
        </div>
        <!-- 创建活动 -->
        <ul class="activity" v-show="tabActive == 1">
          <li
            class="item"
            v-for="(item, index) in activityForm"
            :key="index"
            :v-model="activityForm"
          >
            <div class="wrap">
              <!-- <div class="imgBorder">
                
              </div> -->
              <div class="imgBox">
                <img :src="item.scr" class="img" />
              </div>
              <div class="info">
                <span class="tit">{{ item.signed }}</span>
                <span class="desc">{{ item.content }}</span>
              </div>
              <div class="btn">
                <button v-zoom='{from:"忠诚度管理-积分任务",name:"创建活动"}' @click="createActivity(item.id)">立即创建</button>
              </div>
              <div class="btnBackground"></div>
            </div>
          </li>
        </ul>
        <!-- 活动管理 -->
        <activity-manage
          v-if="tabActive == 2"
          @changeData="changeData"
          @changeStatus="changeStatus"
          :activityList="activityList"
        ></activity-manage>
      </div>

      <!-- 创建活动步骤 -->
      <create-activity-step
        v-if="createStep == 2"
        @returnBack="returnBackChange"
        @saveEdit="saveEditChange"
        :activityData="activityData"
      ></create-activity-step>
      <create-invite-step
        v-if="createStep == 5"
        @returnBack="returnBackChange"
        @saveEdit="saveEditChange"
        :activityData="activityData"
      ></create-invite-step>

    </div>
  </div>
</template>

<script>
import topTitle from "../../components/top-title";
import createActivityStep from "./points_task_activity";
import createInviteStep from "./points_task_Invite";
import activityManage from "./activityManage";
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";

export default {
  components: {
    topTitle,
    createActivityStep,
    createInviteStep,
    activityManage,
  },
  data() {
    return {
      // seen: true,
      // seen2: true,
      // 导航选中
      tabActive: 1,
      createStep: 1,
      activityData: null,
      activityForm: [
        {
          id: 1,
          signed: "日历签到",
          content: "支持每日签到、连续签到、累计签到多种赠送方式，增强会员粘性",
          scr: require("../../assets/images/integralCenter/jifenrenwu_riliqiandao.png"),
        },
        {
          id: 3,
          signed: "每日抢好礼",
          content: "限时限量发放好礼，制造紧迫感，吸引会员定时参与店铺活动",
          scr: require("../../assets/images/integralCenter/jifenrenwu_meiriqianghaoli.png"),
        },
        {
          id: 4,
          signed: "关注店铺有礼",
          content:
            "关注店铺赢好礼，可增加店铺关注量，提升店铺权重，支持设置曝光商品，刺激转化提客户粘性，推广店铺必推玩法",
          scr: require("../../assets/images/integralCenter/jifenrenwu_guanzhudianpuyouli.png"),
        },
        {
          id: 5,
          signed: "邀请开卡",
          content:
            "引导客户邀请好友开卡，迅速增加活动曝光率，提升店铺流量，提升转化率",
          scr: require("../../assets/images/integralCenter/jifenrenwu_yaoqingkaika.png"),
        },
        {
          id: 6,
          signed: "邀请关注店铺",
          content:
            "引导客户邀请好友关注店铺，迅速增加活动曝光率，提升店铺流量，提升转换率",
          scr: require("../../assets/images/integralCenter/jifenrenwu_yaoqingguanzhudianpu.png"),
        },
        {
          id: 7,
          signed: "完善信息有礼",
          content: "收集店铺会员信息，提交后赠送礼品，完善店铺会员标签",
          scr: require("../../assets/images/integralCenter/jifenrenwu_wanshanxinxiyouli.png"),
        },
      ],
      // 活动列表
      activityList: [
        // {
        //   name: "日历签到20200526 21:43:59",
        //   type: "日历签到",
        //   startTime: "2020-04-19 22：59：17",
        //   endTime: "2020-04-26 23：59：59",
        //   lastChangeTime: "2020-05-27 16:30:49",
        //   createShop: "小云旗舰店",
        //   status: 1,
        // },
      ],
      allHide: true,
      activityUrl: "",
      venderId: "",
      idUrl1: "",
      idUrl2: "",
      idUrl3: "",
      idUrl4: "",
      idUrl5: "",
      idUrl6: "",
      idUrl7: "",
    };
  },
  created() {
    this.prefixQue();
  },
  mounted() {},
  methods: {
    //获取活动地址
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
          this.idUrl1 =
            this.activityUrl +
            "/point-h5/" +
            "sign_polite" +
            "?venderId=" +
            this.venderId;
          this.idUrl2 =
            this.activityUrl +
            "/point-h5/" +
            "sign_polite" +
            "?venderId=" +
            this.venderId;
          this.idUrl3 =
            this.activityUrl +
            "/point-h5/" +
            "rob_goodPresent" +
            "?venderId=" +
            this.venderId;
          this.idUrl4 =
            this.activityUrl +
            "/point-h5/" +
            "attention_shop" +
            "?venderId=" +
            this.venderId;
          this.idUrl5 =
            this.activityUrl +
            "/point-h5/" +
            "invitationopenCard" +
            "?venderId=" +
            this.venderId;
          this.idUrl6 =
            this.activityUrl +
            "/point-h5/" +
            "invitationattention" +
            "?venderId=" +
            this.venderId;
          this.idUrl7 =
            this.activityUrl +
            "/point-h5/" +
            "perfect_information" +
            "?venderId=" +
            this.venderId;
        })
        .catch((res) => {});
    },
    createActivity(type) {
      // 邀请开卡初始化另一个组件
      if (type==5) {
        this.createStep = 5;
        this.activityData = {
          id: 4,
          name: "邀请开卡",
          telImg: require("../../assets/images/integralCenter/kk.jpg"),
          telCode: this.idUrl5,
        };
        return 
      }
      this.createStep = 2;
      switch (type) {
        case 1:
          this.activityData = {
            id: 1,
            name: "日历签到",
            telImg: require("../../assets/images/integralCenter/qdq.jpg"),
            telCode: this.idUrl1,
          };
          break;
        case 3:
          this.activityData = {
            id: 2,
            name: "每日抢好礼",
            telImg: require("../../assets/images/integralCenter/mrq.jpg"),
            telCode: this.idUrl3,
          };
          break;
        case 4:
          this.activityData = {
            id: 3,
            name: "关注店铺有礼",
            telImg: require("../../assets/images/integralCenter/gzdp.jpg"),
            telCode: this.idUrl4,
          };
          break;
        case 5:
          this.activityData = {
            id: 4,
            name: "邀请开卡",
            telImg: require("../../assets/images/integralCenter/kk.jpg"),
            telCode: this.idUrl5,
          };
          break;
        case 6:
          this.activityData = {
            id: 5,
            name: "邀请关注店铺",
            telImg: require("../../assets/images/integralCenter/yqgz.jpg"),
            telCode: this.idUrl6,
          };
          break;
        case 7:
          this.activityData = {
            id: 6,
            name: "完善信息有礼",
            telImg: require("../../assets/images/integralCenter/wsxx.jpg"),
            telCode: this.idUrl7,
          };
          break;
      }
    },
    returnBackChange() {
      this.createStep = 1;
      // this.allHide = true;
      // console.log(this.allHide, "returnBackChange");
    },
    saveEditChange() {
      this.createStep = 1;
      this.tabActive = 2;
      // this.allHide = true;
      // console.log(this.allHide, "saveEditChange");
    },
    changeData() {
      this.allHide = false;
    },
    changeStatus() {
      this.allHide = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.integralEden {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1080px;
  .content {
    min-height: 980px;
    margin: 20px 0 30px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .navTab {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 20px;
      position: relative;
      height: 50px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #f6f6f6;
      span {
        height: 50px;
        line-height: 50px;
        position: relative;
        padding: 0 11px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .active {
        color: #fe4d45;
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 80%;
          height: 2px;
          background-color: #fe4d45;
          transition: all 0.2s;
          animation: opation 0.2s;
        }
        @keyframes opation {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 100%;
          }
        }
      }
    }
    .activity {
      display: flex;
      flex-wrap: wrap;
      align-content: baseline;
      box-sizing: border-box;
      padding: 30px 14px;
      list-style: none;
      height: 500px;
      min-width: 1366px;
      .item {
        position: relative;
        flex: 1;
        max-width: 31.63%;
        min-width: 31.63%;
        box-sizing: border-box;
        margin: 0 14px;
        margin-bottom: 20px;
        .wrap {
          display: flex;
          box-sizing: border-box;
          padding: 0 15px;
          height: 200px;
          // box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
          border: 1px solid #EEE;
          border-radius: 6px;
          background-color: #fff;
          transition: all 0.2s;
          .btn {
            display: none;
            opacity: 0;
          }
          &:hover {
            // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2);
            border: 1px solid #fe4d45;
            // opacity: 1;
            .btn {
              display: inline;
              opacity: 1;
              z-index: 100;
              position: absolute;
              left: 50%;
              top: 50%;
              margin: -16px 0 0 -47px;
              text-align: right;
              button {
                width: 94px;
                height: 32px;
                line-height: 28px;
                text-align: center;
                border-radius: 3px;
                border: 1px;
                color: #fe4d45;
                background-color: #fe4d45;
                color: #fff;
                cursor: pointer;
                outline: none;
                transition: all 0.2s;
                &:hover {
                  background-color: #fa6c6c;
                  color: #fff;
                }
              }
            }
            .btnBackground {
              border-radius: 6px;
              position: absolute;
              top: 15px;
              left: 2px;
              flex: 1;
              width: 98%;
              // min-width: 100%;
              box-sizing: border-box;
              padding:  14px;
              margin-bottom: 20px;
              height: 150px;
              background: rgb(255, 255, 255);
              opacity: 0.7;
            }
          }
          // .imgBorder {
          //   border: 1px solid #ffe8ce;
          //   background: #ffe8ce;
          //   border-radius: 40px;
          //   height: 80px;
          //   opacity: 1;
          //   position: absolute;
          //   top: 50%;
          //   margin: -40px 0 0 20px;
          //   width: 80px;
          // }
          .imgBox {
            .img {
              position: absolute;
              // flex-shrink: 0;
              top: 50px;
              left: 26px;
              width: 80px;
              height: 80px;
              margin: 9px 0 0 9px;
            }
          }
          .info {
            margin-left: 120px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 30px 0 16px 0;
            .tit {
              margin-top: 30px;
              font-size: 16px;
              color: #333;
            }
            .desc {
              margin-bottom: 40px;
              font-size: 14px;
              line-height: 26px;
              color: #333;
            }
          }
        }
      }
    }
  }
}
</style>
